var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90337 9.47359V10.4829L5.98697 11L5.09663 10.4829V9.47359L5.98697 9.99073L6.90337 9.47359ZM2 5.98285L2.89034 6.5V8.23077L4.42345 9.11075V10.12L2 8.74791V5.98285ZM9.97394 5.98285V8.75208L7.52443 10.1242V9.11492L9.05755 8.23494V6.50417L9.97394 5.98285ZM7.52009 4.61075L8.43648 5.1279V6.13716L6.90337 7.01714V8.77294L6.01303 9.29008L5.12704 8.77294V7.01297L3.53746 6.13299V5.12373L4.45385 4.60658L5.98697 5.48656L7.52009 4.61075ZM3.53746 6.85866L4.4278 7.37581V8.38508L3.53746 7.86793V6.85866ZM8.43648 6.85866V7.86793L7.54615 8.38508V7.37581L8.43648 6.85866ZM2.89034 3.73077L3.80673 4.24791L2.89034 4.76506V5.77433L2 5.25718V4.24791L2.89034 3.73077ZM9.0836 3.73077L10 4.24791V5.25718L9.0836 5.77433V4.76506L8.19327 4.24791L9.0836 3.73077ZM5.98697 3.73077L6.90337 4.24791L5.98697 4.76506L5.09663 4.24791L5.98697 3.73077ZM5.98697 2L8.43648 3.3721L7.54615 3.88925L6.01303 3.00927L4.44951 3.88925L3.55918 3.3721L5.98697 2Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.dd19c2f1.svg";
export { ForwardRef as ReactComponent };